import ConversationWithCompany from 'domain/conversations/ConversationWithCompany';
import React, { useState } from 'react';
import { ICompany, LimitedFundingRound } from 'types/company';
import Button from 'ui/elements/buttons/Button';
import ChatBubblesIcon from 'ui/elements/icons/ChatBubblesIcon';
import CardInfoCard from 'ui/views/cards/CardInfoCard';
import { getFundingRoundClosingDateText } from './FundingRound';

interface Props {
  company: ICompany;
  fundingRound: LimitedFundingRound;
  className?: string;
}

export default function FundingRoundLimitedView(props: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <CardInfoCard
        className="u-half-spacing-bottom"
        title="Active funding round"
        subTitle={getFundingRoundClosingDateText(props.fundingRound)}
      >
        <Button kind={'secondary'} color="white" onClick={() => setIsOpen(true)}>
          <ChatBubblesIcon className="u-half-spacing-right" /> I&apos;m interested
        </Button>
      </CardInfoCard>
      {isOpen && <ConversationWithCompany onClose={() => setIsOpen(false)} company={props.company} />}
    </>
  );
}
